import "./utils/suppressResizeObserver";
import "./App.css";
import React from "react";
import ReactDOM from "react-dom";
import Routes from "./Routes";
import { ConfigProvider } from "antd";
import { NotificationProvider } from "./context/NotificationContext";

ReactDOM.render(
	<ConfigProvider
		theme={{
			token: {
				colorPrimary: "#233F86",
			},
		}}
	>
		<React.StrictMode>
			<NotificationProvider>
				<Routes />
			</NotificationProvider>
		</React.StrictMode>
	</ConfigProvider>,
	document.getElementById("root"),
);

// import React from "react";
// import { createRoot } from "react-dom/client";
// import Routes from "./Routes";
// import { ConfigProvider } from "antd";
// import { NotificationProvider } from "./context/NotificationContext";

// const root = createRoot(document.getElementById("root"));

// root.render(
// 	<ConfigProvider
// 		theme={{
// 			token: {
// 				colorPrimary: "#233F86",
// 			},
// 		}}
// 	>
// 		<React.StrictMode>
// 			<NotificationProvider>
// 				<Routes />
// 			</NotificationProvider>
// 		</React.StrictMode>
// 	</ConfigProvider>
// );
